import React from 'react'

const IndexContext = React.createContext(null)

export const Provider = IndexContext.Provider
export const Consumer = IndexContext.Consumer

export default IndexContext
